import React from 'react';
import cookie from 'react-cookies';
import { AuthContext } from './authContext';
import { COOKIE_TOKEN } from '../../Utils/cookies';
import axiosInstance from '../../axios';
import { jwtDecode } from 'jwt-decode';

function AuthProvider(props) {
    const [token, setToken] = React.useState(cookie.load(COOKIE_TOKEN) || null);
    let expirationDate = null;

    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            if (decodedToken.exp) {
                expirationDate = new Date(decodedToken.exp * 1000);
            }
        } catch (error) {
            console.error("Invalid Token:", error);
            expirationDate = null; // Reset expiration if token is invalid
        }
    }

    React.useEffect(() => {
        if (token) {
            axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + token;
        }
    }, [token]);

    const handleToken = (data) => {
        try {
            const decodedToken = jwtDecode(data);
            const newExpirationDate = new Date(decodedToken.exp * 1000);
            cookie.save(COOKIE_TOKEN, data, { path: '/', expires: newExpirationDate });
            setToken(data);
        } catch (error) {
            console.error("Error decoding token:", error);
        }
    };

    const logout = () => {
        cookie.remove(COOKIE_TOKEN, { path: '/' });
        setToken(null);
    };

    return (
        <AuthContext.Provider
            value={{
                token,
                logout,
                handleToken,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;